<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <!-- <el-form-item label="播放次数">
      <el-input-number v-model="ruleForm.playTimes" :min="1"></el-input-number>
    </el-form-item> -->
    <el-form-item label="播放文字">
      <el-input
        type="textarea"
        v-model="ruleForm.playContent"
        style="width: 79rem"
      ></el-input>
    </el-form-item>
    <el-form-item label="关联设备" style="margin-top: 1.2rem">
      <div
        class="bgcolor"
        style="
          display: inline-block;
          width: 79rem;
          height: 30rem;
          overflow: auto;
          padding: 10px;
        "
      >
        <el-checkbox-group v-model="ruleForm.relationEquipmentIds">
          <el-checkbox
            v-for="item in Devices"
            :label="item.id"
            :key="item.id"
            >{{ item.equipmentName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import { getEquipmentCode, listEquipment } from "@/api/src/equipment";
export default {
  name: "ZjComponentradioDetail",
  controller: "UI",
  action: "ComponentradioDetail",
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String,
    form: Object,
  },
  data() {
    return {
      ruleForm: {
        playContent: "",
        playTimes: 1,
        relationEquipmentIds: [],
      },
      Devices: [],
    };
  },
  created: function () {
    this.init()
  },
  methods: {
    // 获取设备code
    init(){
      // this.showLoading("加载中...");
      // getEquipmentCode('fireEquipment').then(response =>{
      //   this.getList(response.data);
      //   this.hideLoading();
      // }).catch(() =>{
      //   this.hideLoading();
      // });
      this.getList('broadcast');
    },
        // 查询
    getList(categoryCode) {
      this.showLoading("加载中...");
      let queryParams =  {
          pageNum: 1,
          pageSize: 10000,
          onlineStatus: 1,
          categoryCode
      }
      listEquipment(queryParams).then(response =>{
        this.Devices = response.rows;
        this.hideLoading();
      }).catch(() =>{
        this.hideLoading();
      });
    },
    showLoading(text) {
      this.$emit("loading", text);
    },
    hideLoading() {
      this.$emit("loadingFinish");
    },
    Gettaskreceiver() {
      return  {...this.ruleForm};
    },
    setDefaultCheckItems(){
      let { broadcast } = this.form
      if(broadcast){
        this.ruleForm = broadcast
      }
    }
  },
  watch:{
    'form.broadcast':{
       handler(val, oldVal) {
        if (val) {
         this.setDefaultCheckItems()
        }
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>